import type React from 'react';
import { Chip } from '@heroui/react';
import { env } from '@/config/env';
import type { ModeDisplay } from '@/utils/appMode';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

type ModeBadgeProps = {
    className?: string;
    /** The mode to show; the running bundle's own by default (tests pass one). */
    display?: ModeDisplay;
};

const MODE_COLORS = {
    local: 'accent',
    development: 'warning',
} as const;

/**
 * Which run mode and API a development build is using (BOS-236), e.g.
 * `DEV · dev-api.bos.plus`, beside the build commit in the sidebar footer. A
 * technical label, so it is not translated. Production renders nothing.
 */
export const ModeBadge: React.FC<ModeBadgeProps> = ({
    className,
    display = env.modeDisplay,
}) => {
    if (display.mode === 'production' || !display.badgeLabel) {
        return null;
    }

    return (
        <Chip
            className={className}
            color={MODE_COLORS[display.mode]}
            size="sm"
            variant="soft"
            {...getNodeTestIdProp('mode-badge')}
        >
            {display.badgeLabel}
        </Chip>
    );
};
